import manifest from "@/data/dev-image-library.json";

export const DEV_IMAGE_LIBRARY_DIR = "/assets/imgs/dev-library";

export type DevImageUsageRef = {
  label: string;
  href?: string;
};

export type DevImageLibraryManifestEntry = {
  id: string;
  title: string;
  label: string;
  filename: string;
  path: string;
  originalSlug: string;
  usedIn?: DevImageUsageRef[];
};

export type DevImageLibraryEntry = DevImageLibraryManifestEntry & {
  inUse: boolean;
  usedIn: DevImageUsageRef[];
};

type DevImageLibraryManifest = {
  images: DevImageLibraryManifestEntry[];
};

const libraryManifest = manifest as DevImageLibraryManifest;

function enrichDevImageLibraryEntry(
  entry: DevImageLibraryManifestEntry,
): DevImageLibraryEntry {
  const usedIn = entry.usedIn ?? [];
  return {
    ...entry,
    usedIn,
    inUse: usedIn.length > 0,
  };
}

export function getDevImageLibraryEntries(): DevImageLibraryEntry[] {
  return libraryManifest.images.map(enrichDevImageLibraryEntry);
}

export function getDevImageLibraryManifestEntries(): DevImageLibraryManifestEntry[] {
  return libraryManifest.images;
}

export function getDevImageLibraryEntryById(
  id: string,
): DevImageLibraryManifestEntry | undefined {
  return libraryManifest.images.find((entry) => entry.id === id);
}

/** Stable path constant for imports in app code (e.g. hero backdrops). */
export function devImageLibraryPath(id: string): string | null {
  return getDevImageLibraryEntryById(id)?.path ?? null;
}
